
import { useNavigate } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

interface ResetPasswordErrorProps {
  error: string;
}

export default function ResetPasswordError({ error }: ResetPasswordErrorProps) {
  const navigate = useNavigate();
  
  return (
    <Card className="w-full max-w-md">
      <CardHeader className="space-y-1">
        <CardTitle className="text-2xl font-bold text-destructive flex items-center gap-2">
          <AlertTriangle className="h-6 w-6" />
          Error
        </CardTitle>
        <CardDescription>
          {error}
        </CardDescription>
      </CardHeader>
      <CardFooter className="flex flex-col space-y-4 pt-4">
        <Button 
          onClick={() => navigate('/forgot-password')}
          className="w-full"
        >
          Try Again
        </Button>
      </CardFooter>
    </Card>
  );
}
